class VariantSelect extends HTMLElement {
	static ACTIVE_CLASS = 'variant-select--active';
	static SELECTED_CLASS = 'variant-select__option--selected';
	static PIVOT_OPTION_CHANGED_EVENT_NAME = 'variant-select_pivot-option-changed';
	constructor() {
		super();
		if (this.isValidPickerType()) {
			this.initializeVariantSelect();
		}
	}

	isValidPickerType() {
		const pickerType = this.dataset.pickerType;
		const PICKER_TYPE_DROPDOWN = 'dropdown';
		return pickerType === PICKER_TYPE_DROPDOWN;
	}

	initializeVariantSelect() {
		this.active = false;
		this.position = parseInt(this.dataset.position);
		this.elements = {
			control: this.querySelector('.variant-select__control'),
			details: this.querySelector('.variant-details'),
			head: this.querySelector('.variant-select__head'),
			menu: this.querySelector('.variant-select__menu'),
			options: this.querySelectorAll('.variant-select__option'),
			selected_option: this.querySelector('.variant-select__option--selected'),
			swatch: this.querySelector('.variant-select__head .variant-swatch'),
		};
		this.attachEventListeners();
	}

	attachEventListeners() {
		const { head, options } = this.elements;
		head.addEventListener('click', this.toggle.bind(this));
		options.forEach((option) => {
			option.addEventListener('click', this.handleOptionSelect.bind(this));
		});
		document.addEventListener('click', (event) => {
			if (!this.contains(event.target)) {
				this.close();
			}
		});
		this.addEventListener(VariantSelect.PIVOT_OPTION_CHANGED_EVENT_NAME, (event) => {
			const option = event.target;
			this.updateControlValue(option.dataset.value);
			this.updateSelectedOptionElement(option);
			this.updateHeadAndClose(option);
		});
	}
	updateControlValue(value) {
		this.elements.control.value = value;
	}
	updateHeadAndClose(option) {
		this.updateHead(option);
		this.close();
	}
	close() {
		if (!this.active) {
			return;
		}
		const { menu } = this.elements;
		this.active = false;
		this.classList.remove(VariantSelect.ACTIVE_CLASS);
		menu.ariaExpanded = 'false';
		menu.hidden = true;
	}
	handleOptionSelect(event) {
		if (!event) {
			return;
		}
		const option = event.currentTarget;
		this.updateControlValue(option.dataset.value);
		this.updateSelectedOption(option);
		this.updateHeadAndClose(option);
	}
	open() {
		if (this.active) {
			return;
		}
		const { menu } = this.elements;
		this.active = true;
		this.classList.add(VariantSelect.ACTIVE_CLASS);
		menu.ariaExpanded = 'true';
		menu.hidden = false;
	}
	toggle() {
		this.active ? this.close() : this.open();
	}
	updateHead(option) {
		if (!option) {
			return;
		}
		const { details, swatch } = this.elements;
		details.innerHTML = option.querySelector('.variant-details').innerHTML;
		if (swatch) {
			const newSwatch = option.querySelector('.variant-swatch');
			if (newSwatch != null) {
				swatch.innerHTML = newSwatch.innerHTML;
			}
		}
	}
	updateSelectedOption(option) {
		if (!option) {
			return;
		}
		this.updateSelectedOptionElement(option);
		this.dispatchChangeEvents(option);
	}
	updateSelectedOptionElement(option) {
		if (!option) {
			return;
		}
		option.classList.add(VariantSelect.SELECTED_CLASS);
		this.elements.selected_option.classList.remove(VariantSelect.SELECTED_CLASS);
		this.elements.selected_option = option;
	}
	dispatchChangeEvents(optionElement) {
		const picker = this.getPickerElement();
		picker.dispatchEvent(new Event('change'));

		const VARIANT_SELECT_CHANGE_EVENT_NAME = 'variant-select_change';
		const variantSelectChangeEvent = new CustomEvent(VARIANT_SELECT_CHANGE_EVENT_NAME, {
			bubbles: true,
			detail: {
				position: this.position,
				optionContainer: optionElement.closest('.variant-option__container'),
			},
		});
		picker.dispatchEvent(variantSelectChangeEvent);
	}
	getPickerElement() {
		const VARIANT_PICKER_SELECTOR = '.variant-picker';
		return this.closest(VARIANT_PICKER_SELECTOR);
	}
}
customElements.define('variant-select', VariantSelect);
